import React from "react";
import { ChevronDown } from 'lucide-react';

function SingleOrderSkeleton() {
  return (
    <div className="bg-gray-100 min-h-screen">
      
      <div className="container mx-auto px-4 py-6 max-w-6xl">
        {/* Breadcrumb Skeleton */}
        <div className="flex items-center text-sm mb-4">
          <div className="h-4 bg-gray-200 rounded w-24"></div>
          <span className="mx-2">›</span>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
          <span className="mx-2">›</span>
          <div className="h-4 bg-gray-200 rounded w-24"></div>
        </div>

        {/* Order Title & Info Skeleton */}
        <div className="mb-4">
          <div className="h-8 bg-gray-200 rounded w-48 mb-2"></div>
          <div className="flex flex-wrap items-center justify-between mt-2">
            <div className="flex flex-wrap items-center">
              <div className="h-4 bg-gray-200 rounded w-36 mr-4"></div>
              <div className="h-4 bg-gray-200 rounded w-48"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-20"></div>
          </div>
        </div>

        {/* Order Details Card Skeleton */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Shipping Address Skeleton */}
            <div>
              <div className="h-6 bg-gray-200 rounded w-40 mb-3"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-32"></div>
                <div className="h-4 bg-gray-200 rounded w-48"></div>
                <div className="h-4 bg-gray-200 rounded w-40"></div>
                <div className="h-4 bg-gray-200 rounded w-24"></div>
                <div className="h-4 bg-gray-200 rounded w-36"></div>
              </div>
            </div>

            {/* Payment Methods Skeleton */}
            <div>
              <div className="h-6 bg-gray-200 rounded w-40 mb-3"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-48"></div>
                <div className="h-4 bg-gray-200 rounded w-36"></div>
                <div className="h-4 bg-gray-200 rounded w-40"></div>
              </div>
            </div>

            {/* Order Summary Skeleton */}
            <div>
              <div className="h-6 bg-gray-200 rounded w-36 mb-3"></div>
              <table className="w-full">
                <tbody>
                  <tr>
                    <td className="py-1"><div className="h-4 bg-gray-200 rounded w-36"></div></td>
                    <td className="text-right"><div className="h-4 bg-gray-200 rounded w-16 ml-auto"></div></td>
                  </tr>
                  <tr>
                    <td className="py-1"><div className="h-4 bg-gray-200 rounded w-20"></div></td>
                    <td className="text-right"><div className="h-4 bg-gray-200 rounded w-16 ml-auto"></div></td>
                  </tr>
                  <tr>
                    <td className="py-1"><div className="h-4 bg-gray-200 rounded w-48"></div></td>
                    <td className="text-right"><div className="h-4 bg-gray-200 rounded w-16 ml-auto"></div></td>
                  </tr>
                  <tr className="border-t border-gray-200">
                    <td className="pt-2"><div className="h-4 bg-gray-200 rounded w-16"></div></td>
                    <td className="pt-2 text-right"><div className="h-4 bg-gray-200 rounded w-20 ml-auto"></div></td>
                  </tr>
                  <tr>
                    <td className="pt-1"><div className="h-5 bg-gray-200 rounded w-24"></div></td>
                    <td className="pt-1 text-right"><div className="h-5 bg-gray-200 rounded w-24 ml-auto"></div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Delivery Status & Product Details Skeleton */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="mb-4 flex flex-row justify-between">
            <div className="flex flex-col">
              <div className="h-6 bg-gray-200 rounded w-40 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-56"></div>
            </div>
            <div className="h-10 bg-gray-200 rounded w-32"></div>
          </div>

          {/* Product Details Skeleton - Repeat for multiple items */}
          {[1, 2].map((item) => (
            <div key={item} className="flex flex-col md:flex-row border-t border-gray-200 pt-6 pb-6">
              <div className="md:w-24 flex-shrink-0 mb-4 md:mb-0 md:mr-6">
                <div className="bg-gray-200 rounded h-24 w-24"></div>
              </div>
              
              <div className="flex-grow">
                <div className="h-5 bg-gray-200 rounded w-72 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-32 mb-1"></div>
                <div className="h-4 bg-gray-200 rounded w-64 mb-2"></div>
                <div className="h-5 bg-gray-200 rounded w-20 mb-4"></div>
                <div className="md:hidden">
                  <div className="h-8 bg-gray-200 rounded w-full"></div>
                </div>
              </div>

              <div className="md:w-64 flex-shrink-0 mt-4 md:mt-0 md:ml-4">
                <div className="flex flex-col space-y-2">
                  <div className="h-10 bg-gray-200 rounded"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SingleOrderSkeleton;